import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useRouterProps } from '../hooks/useRouterProps';
import { ROUTES } from '@lsgo/lsgo-common/constants/routes';

/**
 * Resolve a safe in-app return path from redirectUri (deep links from SIS iframes).
 * Only relative paths are accepted to avoid open redirects.
 */
const resolvePostAuthPath = (redirectUri, fallback) => {
    const candidate = Array.isArray(redirectUri) ? redirectUri[0] : redirectUri;
    if (typeof candidate === 'string' && candidate.startsWith('/') && !candidate.startsWith('//')) {
        return candidate;
    }
    return fallback;
};

/**
 * Guest route guard - redirects authenticated users away
 * Use this for login, register, and other guest-only pages
 */
const GuestRoute = ({ children, render, redirectTo = ROUTES.TEACHER.DASHBOARD.path, ...props }) => {
    const auth = useAuth();
    const routerProps = useRouterProps();

    // If authenticated, redirect away — honor deep-link redirectUri when present
    // (e.g. Sentral/SchoolBytes student profile after SSO login)
    if (auth.isAuthenticated) {
        return <Navigate to={resolvePostAuthPath(auth.redirectUri, redirectTo)} replace />;
    }

    // Not authenticated, allow access
    return render ? render({ ...props, ...routerProps }) : children;
};

export default GuestRoute;
